import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/admin/products', { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!email.trim()) {
      setError('请输入用户名');
      return;
    }
    if (!password) {
      setError('请输入密码');
      return;
    }

    setLoading(true);
    const { error: signInError } = await signIn(email.trim(), password);
    setLoading(false);

    if (signInError) {
      setError(signInError);
    } else {
      navigate('/admin/products', { replace: true });
    }
  };



  return (
    <div className="min-h-screen bg-[#faf9f7] flex items-center justify-center px-4">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-32 -right-32 w-96 h-96 bg-[#C8714A]/8 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-[#e8a87c]/8 rounded-full blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-md">
        <div className="bg-white rounded-2xl p-8 md:p-10 border border-[#f0ece6]">
          <div className="flex flex-col items-center mb-8">
            <div className="flex items-center justify-center bg-[#C8714A] rounded-lg px-5 py-2.5 mb-3">
              <img
                src="https://storage.readdy-site.link/project_files/d60e0add-d934-490f-b5d8-9398c2931d82/d3cef690-9814-4ee5-8d70-6302dcf14eac_2.png?v=8f456bca08344c0bb883917c789b2e55"
                alt="Koorpet"
                className="h-8 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-[#888] mt-1">后台管理系统</p>
          </div>

          <div className="mb-6">
            <h2 className="text-2xl font-bold text-[#1a1a1a]">管理员登录</h2>
            <p className="text-sm text-[#888] mt-1">请使用管理员账号登录</p>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <label className="text-sm font-medium text-[#333]">用户名</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-[#aaa]">
                  <i className="ri-mail-line text-base"></i>
                </div>
                <input
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="请输入管理员账号"
                  className="w-full pl-10 pr-4 py-3 rounded-lg border border-[#e8e4de] bg-[#faf9f7] text-sm text-[#1a1a1a] placeholder-[#bbb] focus:outline-none focus:border-[#C8714A] focus:bg-white transition-all"
                  autoComplete="username"
                />
              </div>
            </div>

            <div className="flex flex-col gap-1.5">
              <label className="text-sm font-medium text-[#333]">密码</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-[#aaa]">
                  <i className="ri-lock-line text-base"></i>
                </div>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="请输入密码"
                  className="w-full pl-10 pr-12 py-3 rounded-lg border border-[#e8e4de] bg-[#faf9f7] text-sm text-[#1a1a1a] placeholder-[#bbb] focus:outline-none focus:border-[#C8714A] focus:bg-white transition-all"
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-[#aaa] hover:text-[#666] cursor-pointer transition-colors"
                >
                  <i className={`text-base ${showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}`}></i>
                </button>
              </div>
            </div>

            {error && (
              <div className="flex items-center gap-2 px-3 py-2.5 rounded-lg border bg-red-50 border-red-100">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 text-red-500">
                  <i className="ri-error-warning-line text-sm"></i>
                </div>
                <span className="text-sm text-red-600">{error}</span>
              </div>
            )}



            <button
              type="submit"
              disabled={loading}
              className="mt-2 w-full py-3 rounded-lg bg-[#C8714A] text-white text-sm font-semibold hover:bg-[#b5603b] active:scale-[0.98] transition-all cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>登录中...</span>
                </>
              ) : (
                <>
                  <i className="ri-login-box-line"></i>
                  <span>登录</span>
                </>
              )}
            </button>
          </form>

          <p className="text-center text-xs text-[#bbb] mt-4">
            仅限授权管理员访问 · Koorpet 后台系统
          </p>
        </div>

        <div className="text-center mt-4">
          <a
            href="/"
            className="text-sm text-[#888] hover:text-[#C8714A] transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-1"></i>
            返回前台网站
          </a>
        </div>
      </div>
    </div>
  );
}